import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/member_block1.png';
import _imports_1 from '@/assets/member_office.png';
const _withScopeId = n => (_pushScopeId("data-v-01aaa2c5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fs-s"
};
const _hoisted_2 = {
  class: "block block1"
};
const _hoisted_3 = {
  class: "text-box d-flex jc-between ai-center main-width"
};
const _hoisted_4 = {
  class: "text-white"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logotitle fs-m light_blue text-orange"
}, "会员计划", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title pt-10 pb-20 fs-xl fw-b"
}, [/*#__PURE__*/_createTextVNode("抓住双碳机遇，"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("成为产业链领导者")], -1));
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})], -1));
const _hoisted_9 = {
  class: "block block2"
};
const _hoisted_10 = {
  class: "main-width content_box"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-l fw-b text-blue pb-10"
}, "加入会员计划有什么好处？", -1));
const _hoisted_12 = {
  class: "earning_list pt-20"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "fw-b pb-10"
};
const _hoisted_15 = {
  class: "item_bottom"
};
const _hoisted_16 = {
  class: "block block4"
};
const _hoisted_17 = {
  class: "main-width content_box text-white"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-l fw-b"
}, "会员体系", -1));
const _hoisted_19 = ["innerHTML"];
const _hoisted_20 = {
  class: "award_list d-flex jc-between main-width"
};
const _hoisted_21 = {
  class: "img_box"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  class: "title_box"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img_box_subtitle"
}, "WELL碳手印活动", -1));
const _hoisted_25 = {
  class: "img_box_title"
};
const _hoisted_26 = {
  class: "item-bottom pt-10 text-center"
};
const _hoisted_27 = {
  class: "fw-b pt-10 text-white"
};
const _hoisted_28 = {
  class: "fs-xs pt-10 text-white"
};
const _hoisted_29 = {
  class: "block block3"
};
const _hoisted_30 = {
  class: "main-width content_box"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-l fw-b text-orange"
}, "申请加入会员计划需要具备哪些条件？", -1));
const _hoisted_32 = {
  class: "d-flex jc-between pt-40 text_img_box"
};
const _hoisted_33 = {
  class: "text-box"
};
const _hoisted_34 = {
  class: "pb-20 item_title"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
import wx from 'weixin-js-sdk';
import { onMounted } from 'vue';
import { useStore } from 'vuex';
export default {
  __name: 'Member',
  setup(__props) {
    const store = useStore();
    const textData = {
      block1: '对于有雄心在产业链内成为领导者的企业而言，<br>制定高水平碳目标，并以此为战略抓手，落实<br>数字化驱动机制，可持续提升品牌影响力及业<br>务发展力。加入碳手印会员计划，对于实现上<br>述愿景将大有助益',
      block2: '*越来越多的伙伴加入我们，展示<br>他们优秀的控碳案例。',
      block3: '与我们一起分享经验与资源，获得更多的碳手印服务',
      block4: '基于初心和使命，成为WELL碳手印会员单位，携手开展减碳增效活动，实现可持续增长。'
    };
    const earningList = [{
      title: '提升公司的影响力',
      content: '作为碳手印活动会员，您可以获得我们的品牌支持，有利于在市场上获得竞争优势。',
      url: require('@/assets/member_auth.png')
    }, {
      title: '有更多的社交机会',
      content: '获得与碳界领先组织合作的机会，提升企业的业务发展力。',
      url: require('@/assets/member_team.png')
    }, {
      title: '在地方上产生影响',
      content: '通过我们的培训和各类活动，可以让您的企业在地方或国家层面上产生一定的影响。',
      url: require('@/assets/member_discovery.png')
    }, {
      title: '将专家知识转化为生产力',
      content: '我们拥有超过100位碳手印专家，会员单位可以通过深入合作将碳手印知识转化为生产力。',
      url: require('@/assets/member_communicate.png')
    }];
    const signupList = [{
      title: '① 认同碳手印组织及WELL碳手印理念',
      content: '注册并完善好信息。'
    }, {
      title: '② 委派代表学习和了解碳手印知识',
      content: '学习我们的核心资源和学习资料。'
    }, {
      title: '③ 委派代表参与碳手印活动',
      content: '注册并完善好信息。'
    }, {
      title: '④ 缴纳年度会员费用（可享受碳手印项目创建咨询费折扣）',
      content: '通过不断学习让自己在不断发展的行业保持领先。'
    }
    // { title: '⑤ 点击下方链接申请会员', content: '申请成为碳手印活动会员。' }
    ];

    const memberList = [{
      title: '基石会员',
      content: '适合自愿将本单位减碳增效水平与　　碳手印标准对焦的企业和组织',
      url: require('@/assets/logo/blue_logo_bg.png')
    }, {
      title: '柱石会员',
      content: '适合自愿采用碳手印标准将减碳增效\n活动扩展到上下游伙伴的企业和组织',
      url: require('@/assets/logo/green_logo_bg.png')
    }, {
      title: '钻石会员',
      content: '适合自愿通过支持碳手印活动　　　　创造公共价值的企业和组织',
      url: require('@/assets/logo/purple_logo_bg.png')
    }];
    const toApplyPage = () => {
      location.href = "https://f.wps.cn/g/cpEWp9eG/";
    };
    const wxFunc = function () {
      const params = store.state.VUEX_SHARECONFIG.member;
      wx.ready(function () {
        //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          ...params,
          success: function () {
            // 设置成功
          }
        });
      });
    };
    onMounted(() => {
      wxFunc();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createElementVNode("div", {
        class: "slogantext pb-20",
        innerHTML: textData.block1
      }, null, 8, _hoisted_7), _createVNode(_component_el_button, {
        class: "btn text-orange",
        color: "#fff",
        onClick: toApplyPage
      }, {
        default: _withCtx(() => [_createTextVNode("申请成为会员")]),
        _: 1
      })]), _hoisted_8])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(earningList, (item, idx) => {
        return _createElementVNode("div", {
          class: "list-item pb-40",
          key: idx
        }, [_createElementVNode("img", {
          src: item.url
        }, null, 8, _hoisted_13), _createElementVNode("div", _hoisted_14, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(item.content), 1)]);
      }), 64))])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", {
        class: "title fs-m pt-10 pb-40",
        innerHTML: textData.block4
      }, null, 8, _hoisted_19)]), _createElementVNode("div", _hoisted_20, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(memberList, (item, idx) => {
        return _createElementVNode("div", {
          class: "list-item",
          key: idx
        }, [_createElementVNode("div", _hoisted_21, [_createElementVNode("img", {
          src: item.url
        }, null, 8, _hoisted_22), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, _toDisplayString(item.title), 1)])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_28, _toDisplayString(item.content), 1)])]);
      }), 64))])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(signupList, (item, idx) => {
        return _createElementVNode("div", {
          class: "",
          key: idx
        }, [_createElementVNode("div", _hoisted_34, _toDisplayString(item.title), 1)]);
      }), 64)), _createVNode(_component_el_button, {
        class: "btn text-orange",
        color: "#fff",
        onClick: toApplyPage
      }, {
        default: _withCtx(() => [_createTextVNode("申请成为会员")]),
        _: 1
      })]), _hoisted_35])])])]);
    };
  }
};